/*
 * Address Field Constants
 */
export const ADDRESS_PROPS = [
  'municipality', // irvine
  'countryPrimarySubdivision', // CA
  'countrySecondarySubdivision', // Orange County
  'postalCode', // 92627
  'streetUnit', // APT # 22
]

/*
 * streetName and streetUnit also required but AddressSuggestionField handles that
 */
export const ADDRESS_OPTIONAL_REQUIRED_PROPS = ['postalCode', 'municipality']
